/**
 * ElmerCat Block - View Script
 */

import { renderBlock } from "../script";
import metadata from "./block.json";

import Block from "./time";

renderBlock(Block, metadata);

console.log("Juliete M. Belanger — " + document.currentScript.id);
